
























	import Vue from 'vue';
	import style from './style.module.scss'
	
	export default Vue.extend({
		name: 'radio',
		props: {
			model: String,
			value: {
				type: [Object as () => any, Boolean, String],
				required: false
			},
			label: {
				type: [Object, String, Number, Boolean],
			},
			theme: {
				type: String,
				default: '',
				required: false
			},
			disabled: {
				type: Boolean,
				default: false,
				required: false
			},
            name: {
                type: String,
                default: 'default name',
                required: false
            }
		},
		data() {
			return {
				style: style
			}
		},
		computed: {
			radioButtonValue: {
				get(): any {
					return this.value;
				},
				set(): void {
					this.$emit("change", this.label)
				}
			},
			classNames(): string[] {
				const classNames = [this.style.radio];

				// switch (this.theme) {
				// 	case 'white':
				// 		classNames.push(this.style.radioWhite)
				// 		break;
				// 	default:
				// 		classNames.push(this.style.radioBlack)
				// 		break;
				// }

				return classNames;
			}
		}
	})
